export const getHarvest = (harvestId) => ({ harvests: { harvestsList } }) =>
  harvestsList.find(({ id }) => id === +harvestId);
